import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetActivitySyncStatus as GetActivitySyncStatusQuery,
    GetActivitySyncStatusVariables as GetActivitySyncStatusVariables,
} from 'nutshell-graphql-types';

import GET_ACTIVITY_SYNC_STATUS from '../queries/get-activity-sync-status.graphql';

export const useGetActivitySyncStatus = (
    activityId: string,
    skip = false
): {
    isConnectedToExternalCalendar: boolean | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    startPolling: (arg1: number) => void;
    stopPolling: () => void;
} => {
    const {loading, data, error, startPolling, stopPolling} = useQuery<
        GetActivitySyncStatusQuery,
        GetActivitySyncStatusVariables
    >(GET_ACTIVITY_SYNC_STATUS, {
        variables: {
            activityId,
        },
        skip: skip,
        fetchPolicy: 'network-only',
    });

    const activity = data ? data.activity : null;
    const isConnectedToExternalCalendar = activity ? activity.isConnectedToExternalCalendar : null;

    return {
        isConnectedToExternalCalendar,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        startPolling,
        stopPolling,
    };
};
